/* import __COLOCATED_TEMPLATE__ from './news-screen.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();